export default {
    key: 'swa',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: undefined,
    categoryId: '8fe8dfc0-8d5b-4af1-9d20-6d2f3b271872',
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    isLocalListing: false,
    steps: [
        {
            routeName: 'offerFlow-swa-steps-step-1-activity',
            name: 'offerFlow.pages.stepActivitySelection.name.common',
        },
        {
            routeName: 'offerFlow-swa-steps-step-2-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-swa-steps-step-3-options',
            name: 'offerFlow.pages.stepActivityOptions.name.common',
        },
        {
            routeName: 'offerFlow-swa-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],

} satisfies ProductConfigActivity;
